export const TOOLTIP_TOTAL_ASSETS =
  "The total number of active and inactive assets.";
export const TOOLTIP_ACTIVE_ASSETS =
  "The total number of assets that are assigned to a Sentinel device.";
export const TOOLTIP_INACTIVE_ASSETS =
  "The total number of assets that are not assigned to a Sentinel device.";
export const TOOLTIP_READY_ASSETS =
  "Assets that have been assigned to a Sentinel device and are ready to be powered on.";
export const TOOLTIP_IMPACT_DETECTED =
  "A potential impact that was detected by the Sentinel unit.  It is advised to physically inspect the asset for damage.";
export const TOOLTIP_WORK_IN_PROGRESS =
  "When an asset has been impacted, you are able to place assets in work in progress through the alarms section, or through the email/text.  Once the asset is in work in progress mode, impact alerts will be disabled on this asset until repair is complete.";
export const TOOLTIP_CRITICAL_WARNINGS =
  "Loss of communication with the Sentinel device, battery below 5%, or low signal strength.";
export const TOOLTIP_REGULAR_WARNINGS =
  "Battery below 25%, orientation change.";
export const TOOLTIP_EXPIRED_SUBSCRIPTION =
  "Assets with subscriptions that are expired.";
export const TOOLTIP_CUSTOMER_EMAIL_INTERVAL =
  "This option limits the amount of consecutive impact alerts sent from the Sentinel dashboard. You are able to choose to receive every impact notification, or have them summarized.";
